import "../../../style/controls/input_tags_editor.scss";
import _L from '../../util/Labels';
import { InputTags } from "../components/InputTags/InputTags";
import { UIUtilGlobalKeyEvents } from "../util/GlobalKeyEvent";
import { NotificacionV2 } from './NotificacionV2';

interface TagData {
    value: string
    hexColor?: string
}

export type InputTagsEditorBaseTagData = TagData

export interface InputTagsEditorParams {
    MaxTags?: number
    MaxTagLength?: number
    OnTagAdd?: (event: InputTags.AddEventData) => void
    TagClick?: (event: InputTags.ClickEventData) => void
}

export class InputTagsEditor {
    private input: HTMLInputElement
    private inputTags: InputTags
    private cfg: InputTagsEditorParams

    constructor(inputRef: HTMLInputElement, config?: InputTagsEditorParams) {
        this.input = inputRef
        this.cfg = config || {}

        this.InitTagify();
    }

    public _SetColorAtValue(value: string, hexColor: string): this {
        const tag = this.inputTags._GetTagByValue(value)
        if (tag)
            tag._HexColor = hexColor

        return this
    }

    public _SetTagsData(tagsData: TagData[]): this {
        this.inputTags._SetTags(tagsData)

        return this
    }

    public _GetTagsData(): TagData[] {
        const tags = this.inputTags._GetAllTags()
        return tags.map(tag => ({
            value: tag._Value,
            hexColor: tag._HexColor
        }))
    }

    private InitTagify() {
        const input: HTMLInputElement = this.input
        const cfg: InputTagsEditorParams = this.cfg

        const inputTags = new InputTags(input, {
            MaxTags: cfg.MaxTags || undefined,
            MaxTagLength: cfg.MaxTagLength || undefined,
            Separators: [","], // separadores
            Callbacks: {
                TagClick: e => onTagClick(e),
                Invalid: e => onTagInvalid(e),
                OnTagAdd: e => onAddTag(e),
                StartTagEditting: () => UIUtilGlobalKeyEvents._StopGlobalListener(),
                CancelTagEditting: () => setTimeout(() => UIUtilGlobalKeyEvents._ActiveGlobalListener(), 100),
                FocusAdderText: () => UIUtilGlobalKeyEvents._StopGlobalListener(),
                BlurAdderText: () => setTimeout(() => UIUtilGlobalKeyEvents._ActiveGlobalListener(), 100),
            }
        });
        this.inputTags = inputTags

        inputTags._ControlContainer.classList.add("input-tags-editor")

        const onTagClick = (event: CustomEvent<InputTags.ClickEventData>) => {
            if (!cfg.TagClick || inputTags._IsEdittingTag) return
            cfg.TagClick(event.detail)
        }

        const onTagInvalid = (event: CustomEvent<InputTags.InvalidTagEventData>) => {
            let errorkey = event.detail.errorKey
            let finalMessage: string
            if (errorkey) {
                const val = event.detail.value
                const messagesMap = {
                    [InputTags.INVALID_TAGALREADYEXISTS]: _L("control.form.val_already_exists", val),
                    [InputTags.INVALID_MAXTAGS]: _L("control.form.max_items", cfg.MaxTags),
                    [InputTags.INVALID_MAXTAGLENGTH]: _L("control.form.max_length", cfg.MaxTagLength)
                }
                finalMessage = messagesMap[errorkey]

            }
            if (finalMessage) {
                NotificacionV2._Mostrar(finalMessage, "ADVERTENCIA")
            }
        }

        const onAddTag = (event: CustomEvent<InputTags.AddEventData>) => {
            if (this.cfg.OnTagAdd)
                this.cfg.OnTagAdd(event.detail)
        }
    }
}